import { Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import RightSidebarPaper from '../../../../components/ui-component/form-component/right-side-bar/RightSidebarPaper';
import { useApplication } from '../../../../context/ApplicationContext';
import { DisplayDate, DisplayDateTime } from '../../../../utils/formats';
import { enumT } from '../../../../utils/helper';

// import Schemas
import Schema from '../../../../lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const FoerderAntragRightSidebar: FC<{}> = () => {
	const { application } = useApplication();

	return (
		<>
			<RightSidebarPaper>
				<span>
					<Typography variant='body1'>Online-Formular:</Typography>
					<Typography fontWeight={500} variant='body1'>
						Antrag
					</Typography>
				</span>

				<span>
					<Typography variant='body1'>Antragstitel:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{get(application, P.Zusammenfassung_Ueberblick_Titel.path, '')}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Status:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{enumT(get(application, P.Status_Status.path, ''))}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Laufzeit von:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDate(get(application, P.Zusammenfassung_Ueberblick_Laufzeit_Von.path))}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Laufzeit bis:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDate(get(application, P.Zusammenfassung_Ueberblick_Laufzeit_Bis.path))}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Erstellt am:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDateTime(get(application, 'attributes.createdAt'))}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Zuletzt geändert am:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDateTime(get(application, 'attributes.updatedAt'))}
					</Typography>
				</span>
			</RightSidebarPaper>
		</>
	);
};
export default FoerderAntragRightSidebar;
